import { Grid, Stack } from "@mui/material";
import { EquipeRessource } from "../equipe-ressource/EquipeRessource";
import { Expert } from "../expert/Expert";
import ApparaitreAnnuaire from "./ApparaitreAnnuaire";
import { ChoixDelegant } from "./ChoixDelegant";
import { GenericTeleExpertiseFormProps } from "./GenericTeleExpertiseForm.types";
import { SubmitCancel } from "./SubmitCancel";
import { useAppSelector } from "../../store";
import { NumeroFacturation } from "../expert/NumeroFacturation";
import NotAuthorizedOnEquipeRessource from "../auth/notAuthorizedOnEquipeRessource";

export default function GenericSollicitationForm({ mode }: GenericTeleExpertiseFormProps) {
	const preferences = useAppSelector((s) => s.expertise.preferences);
	if (!preferences) return <NotAuthorizedOnEquipeRessource />;

	return (
		<Grid
			container
			direction={"column"}
			justifyContent={"center"}
			alignItems={"center"}
			bgcolor={"background.default"}
			sx={{ padding: 2, paddingX: 4 }}
			spacing={4}
		>
            <Grid item>
                <ChoixDelegant />
            </Grid>
			<Stack alignItems={"flex-start"} direction={"column"}>
				{ mode === "Expert" &&
                    <Stack sx={{ padding: 2, paddingX: 4 }}>
                        <NumeroFacturation />
                    </Stack>
				}


			<Stack sx={{ padding: 2, paddingX: 4 }}>
				<ApparaitreAnnuaire />
			</Stack>
			</Stack>
            {mode === "Expert" ? <Expert /> : <EquipeRessource />}
            <Grid item>
                <SubmitCancel />
            </Grid>
		</Grid>
	);
}
